import { SLINKY } from 'HubStyleTokens/colors';
import TicketDropdown from './TicketDropdown';
import UIFlex from 'UIComponents/layout/UIFlex';
import { useTicketPropertyDefinitions } from 'conversations-inbox-lib/tickets/hooks/useTicketPropertyDefinitions';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import styled from 'styled-components';
import { localStorage } from 'conversations-platform/localStorage';
import ReassignmentSelectDropdownContainer from '../../reassignment/ReassignmentSelectDropdownContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CONTEXTUAL_SIDEBAR_STATE = 'CONTEXTUAL_SIDEBAR_STATE';
const OPEN = 'OPEN';
const TICKET_OWNER_ID = 'hubspot_owner_id';

/**
 * The css tricks are workaround for a known issue in UICollapser
 * Once the bug is fixed we should move over to UICollapser
 * More context: https://git.hubteam.com/HubSpot/UIComponents/issues/10857#issuecomment-3253736
 */
const StyledUIFlex = styled(UIFlex).withConfig({
  displayName: "TicketToolbarContent__StyledUIFlex",
  componentId: "sc-1ac44b-0"
})([".second-cloumn{flex-basis:118px;min-height:62px;}@media screen and (max-width:", "){.wide-viewport-only{display:none;}}"], ({
  isSidebarOpen
}) => isSidebarOpen ? '1380px' : '1100px');
const TicketToolbarContent = ({
  ticket,
  threadId,
  inboxId
}) => {
  const definitionsResults = useTicketPropertyDefinitions();
  const sidebarState = localStorage.getItem(CONTEXTUAL_SIDEBAR_STATE);
  if (definitionsResults.loading) {
    return /*#__PURE__*/_jsx(UIFlex, {
      direction: "row",
      style: {
        color: SLINKY
      },
      role: "toolbar",
      "aria-busy": true,
      children: /*#__PURE__*/_jsx(SkeletonText, {})
    });
  }
  return /*#__PURE__*/_jsxs(StyledUIFlex, {
    direction: "row",
    role: "toolbar",
    "aria-busy": false,
    isSidebarOpen: sidebarState === OPEN,
    children: [/*#__PURE__*/_jsx(ReassignmentSelectDropdownContainer, {
      threadId: threadId,
      inboxId: inboxId
    }), definitionsResults.propertyDefinitions.map((property, index) => {
      if (property.hidden) {
        return null;
      }

      // we don't want to render ticketOwner dropdown in Inbox
      if (property.name !== TICKET_OWNER_ID) {
        const columnsClasses = index === 1 ? 'second-cloumn' : 'wide-viewport-only';
        return /*#__PURE__*/_jsx("div", {
          className: columnsClasses,
          children: /*#__PURE__*/_jsx(TicketDropdown, {
            label: property.label,
            property: property,
            ticketId: ticket.id,
            disabled: !ticket.userPermissions.currentUserCanEdit,
            value: ticket.defaultProperties[property.name].value,
            ticket: ticket
          })
        }, property.name);
      }
      return null;
    })]
  });
};
TicketToolbarContent.displayName = 'TicketToolbarContent';
export default TicketToolbarContent;